<ion-header>
    <ion-toolbar>
        <ion-title>{{ 'Select player' | translate }}</ion-title>
        <ion-buttons slot="end">
            <ion-button (click)="close()">
                <ion-icon slot="icon-only" name="close"></ion-icon>
            </ion-button>
        </ion-buttons>
    </ion-toolbar>
</ion-header>

<ion-content>

    <app-list-search [userList]="playerGroups" [isGroupSearch]="true" (searchResult)="playerGroups = $event"></app-list-search>
    <app-empty-page *ngIf="!playerGroups.length && !isLoading" text="{{'No players' | translate}}" iconName="people"></app-empty-page>

    <ion-list *ngIf="authUser && !isLoading && playerGroups?.length">
        <ion-item-group *ngFor="let pg of playerGroups; let i = index">
            <ion-item-divider>
                <ion-label>{{ pg.initial }}</ion-label>
            </ion-item-divider>

            <ng-container *ngFor="let user of pg.players; let k = index">
                <app-player-item *ngIf="canShowUser(user.biographicalInformation?.sex)" [user]="user" (click)="selectPlayer(i, k)"></app-player-item>
            </ng-container>
        </ion-item-group>

    </ion-list>


    <div [hidden]="!isLoading" class="ion-padding content-width" *ngFor="let item of [].constructor(5)">
        <ion-skeleton-text animated style="width: 70%"></ion-skeleton-text>
        <ion-skeleton-text animated style="width: 30%"></ion-skeleton-text>
    </div>

    <ion-fab vertical="bottom" horizontal="end" slot="fixed">
        <ion-fab-button color="primary" (click)="addPlayer()">
            <ion-icon name="add"></ion-icon>
        </ion-fab-button>
    </ion-fab>
</ion-content>

<ion-footer>
    <ion-toolbar>
        <ion-row>
            <ion-col size="6">
                <ion-item lines="none">
                    <ion-label>{{'Male' | translate}}</ion-label>
                    <ion-toggle [(ngModel)]="showMale"></ion-toggle>
                </ion-item>
            </ion-col>
            <ion-col size="6">
                <ion-item lines="none">
                    <ion-label>{{ 'Female' | translate }}</ion-label>
                    <ion-toggle [(ngModel)]="showFemale"></ion-toggle>
                </ion-item>
            </ion-col>
        </ion-row>
    </ion-toolbar>
</ion-footer>